var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x85\xA8\xE6\x9C\x88\xE4\xB8\x9A\xE7\xBB\xA9\xE6\x8A\xA5\xE8\xA1\xA8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE6\xA4\xAD\xE5\x9C\x86\xE5\xBD\xA2",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFC939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6\xE7\xBB\x93\xE5\x90\x88",
    d: "M22.6427 10.144C22.7896 10.144 22.9088 10.2631 22.9088 10.4101V21.8529H23.441C23.7349 21.8529 23.9732 22.0912 23.9732 22.3851C23.9732 22.6791 23.7349 22.9174 23.441 22.9174H8.53872C8.24478 22.9174 8.0065 22.6791 8.0065 22.3851C8.0065 22.0912 8.24478 21.8529 8.53872 21.8529H9.07095V18.9257C9.07095 18.7787 9.19009 18.6596 9.33706 18.6596H11.9982C12.1452 18.6596 12.2643 18.7787 12.2643 18.9257V21.8529H14.3932V14.6679C14.3932 14.5973 14.4212 14.5296 14.4711 14.4797C14.521 14.4298 14.5887 14.4018 14.6593 14.4018H17.3204C17.391 14.4018 17.4587 14.4298 17.5086 14.4797C17.5585 14.5296 17.5865 14.5973 17.5865 14.6679V21.8529H19.7154V10.4101C19.7154 10.2631 19.8346 10.144 19.9815 10.144H22.6427ZM18.3849 8.01507C18.4555 8.01507 18.5231 8.04311 18.573 8.09302C18.623 8.14292 18.651 8.21061 18.651 8.28119V12.0068C18.651 12.0773 18.623 12.145 18.573 12.1949C18.5231 12.2448 18.4555 12.2729 18.3849 12.2729H17.8527C17.7057 12.2729 17.5865 12.1537 17.5865 12.0068V10.0109L11.1386 16.4695C11.0138 16.5944 10.8442 16.6643 10.6676 16.6637C10.491 16.6643 10.3214 16.5944 10.1966 16.4695C9.93891 16.2083 9.93891 15.7886 10.1966 15.5274L16.6551 9.07952H14.6593C14.5887 9.07952 14.521 9.05148 14.4711 9.00158C14.4212 8.95167 14.3932 8.88399 14.3932 8.81341V8.28119C14.3932 8.13422 14.5123 8.01507 14.6593 8.01507H18.3849Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank);
export default __webpack_public_path__ + "static/media/rank.5552a0024c6e85c3a0c5bbc145adaf19.svg";
export { ForwardRef as ReactComponent };